const state = () => ({
    activeWorkout: '',
    opened: false,
    autoCue: true,
    activeSlideIndex: 1,
    cueItems: [],
    cueWithRestItems: [],
    cueWithRestItemsWithCircuit: [],
    circuits: [],
    selectedMoves: [],
    selectedCircuits: [],
    render: true,
})

export default state
